// TODO: use variables and separate files to handle each .env
const LOCAL_URL = "http://127.0.0.1:8000/api/v1/"
const STAGING_URL = "https://staging.alignerbase.com/api/v1/"
const PRODUCTION_URL = "https://alignerbase.com/api/v1/"

// TODO: use variables and separate files to handle each .env
const PORTAL_LOCAL_URL = "http://localhost:3006/"
const PORTAL_STAGING_URL = "https://staging.alignerbase.com/portal/"
const PORTAL_PRODUCTION_URL = "https://alignerbase.com/portal/"

// TODO: use variable from .env file
const server = process.env.GATSBY_ENV || "production"

let API_URL = ""
let PORTAL_URL = ""

switch (server) {
  case "development":
    API_URL = LOCAL_URL
    PORTAL_URL = PORTAL_LOCAL_URL
    break
  case "staging":
    API_URL = STAGING_URL
    PORTAL_URL = PORTAL_STAGING_URL
    break
  default:
    API_URL = PRODUCTION_URL
    PORTAL_URL = PORTAL_PRODUCTION_URL
    break
}

const MAX_NAME_LENGTH = 2

const RECAPTCHA_SITE_KEY = "6Le-UnwlAAAAAJLDkQhSqg2KlHnkOkmeHmXBFuwy"

const GTM = "AW-10934558790"

export { API_URL, PORTAL_URL, MAX_NAME_LENGTH, RECAPTCHA_SITE_KEY, GTM }
